import { FC, Fragment, useState, useEffect } from 'react';
import MenuItem from "@mui/material/MenuItem";
import { useSelector, useDispatch } from "react-redux";
import { Button, Menu } from "@mui/material";
import { IconChevronDown } from "@tabler/icons-react";

import { getDataProjects } from "../../../services/devsServices";
import useCallApiAndLoad from "../../../../../hooks/useCallApiAndLoad";
import { IProject } from "../../../models/Devs";
import { AppStore } from "../../../../../redux/store";
import { ProjectDetailType } from "./types"
import { logoutAction } from "../../../../../redux/features/auth";
import { getAuthToken, unsetAuth } from "../../../../../helpers/authHelper";
import { useNavigate } from 'react-router-dom';
import { fetchResponseAdapter } from "../../../../../adapters/fetchAdapter";

interface ProjectMenuProps {
    detailProject: ProjectDetailType;
}

const ProjectMenu: FC<ProjectMenuProps> = ({ detailProject }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { country } = useSelector((store: AppStore) => store.country);
    const { callEndpoint } = useCallApiAndLoad();
    const user = useSelector((store: AppStore) => store.auth);
    const token = getAuthToken(user);

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<IProject[]>([]);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        const loadPayments = async () => {
            setIsLoading(true);
            // TODO add new fields from backend and new table
            const { status, data } = await callEndpoint(getDataProjects(token));
            if (status === 401) {
                dispatch(logoutAction({}));
                unsetAuth();
                navigate(`/app/${country}/auth/desarrolladoras/login`);
            }
            if (status === 200) {
                setIsLoading(false);
                const response = fetchResponseAdapter(data);
                // setPayments(response.data.items || [])
                setData(response.data.items);
            }
        };
        loadPayments().catch((e) => console.error(e));
    }, []);

    return (
        <Fragment>
            <Button
                id="project-menu-button"
                aria-controls={open ? "project-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                sx={{
                    textTransform: "capitalize",
                    padding: "0",
                }}
            >
                <h1 className="font-semibold text-[#212121] text-2xl lg:text-3xl flex items-center justify-start px-4 lg:p-x0">
                    {detailProject?.name} <IconChevronDown color="#212121" />
                </h1>
            </Button>
            <Menu
                id="project-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "project-menu-button",
                }}
            >
                <div className="px-2 grid grid-cols-1 gap-2">
                    {data?.length > 0 &&
                        data?.map((item: IProject, index: number) => (
                            <MenuItem
                                key={item.id}
                                onClick={() => {
                                    window.open(
                                        `/app/${country}/desarrolladoras/proyectos/${item.id}`,
                                        "_self"
                                    );
                                    handleClose();
                                }}
                                className={`pb-2 py-3`}
                            >
                                <p className="text-xs font-medium text-[#212121] hover:font-semibold">
                                    {item?.name}
                                </p>
                            </MenuItem>
                        ))}
                </div>
            </Menu>
        </Fragment>
    )
}

export default ProjectMenu;